import React, { useState } from "react";
import { ListItem } from "@deere/ux.uxframe-react";
import "../assets/css/SearchPage.css";
import { CRS_SURVEY_CODES, DOWNLOAD_LINK, OS, SCBM_CODE, SCBM_INDIRECT, ST, COO, CRS_SURVEY_TEMPLATES, CM, EM } from "../utils/surveyLiterals"
import { Spinner } from '@deere/ux.uxframe-react'
import { getExcel, getExcelGeneric, getExcelIndirect, getExcelSubtier, getExcelOs, getExcelCoo, getExcelGenericParts } from '../services/download.service';
import { useHistory } from "react-router";
import { getDateFromTimeStamp } from '../utils/utils';
import { Button, Grid, Typography } from "@deere/fuel-react"

export const CampaignListItem = ({
    accessToken,
    campaign,
    responsesSubmitted
}) => {
    const history = useHistory()
    const [downloadingFile, setDownloading] = useState(false)
    const getDownloadFile = (surveyId, campaignId, fileName) => {
        try {
            setDownloading(true)
            getExcel(surveyId, campaignId, accessToken, fileName).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileIndirect = (surveyId, campaignId, fileName) => {
        try {
            setDownloading(true)
            getExcelIndirect(surveyId, campaignId, accessToken, fileName).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileSubtier = (campaignId) => {
        try {
            setDownloading(true)
            getExcelSubtier(campaignId, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    }

    const getDownloadFileGeneric = (surveyId, campaignId, surveyCode, fileName) => {
        try {
            setDownloading(true)
            getExcelGeneric(surveyId, campaignId, surveyCode, accessToken, fileName).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileOs = (surveyId, campaignId, surveyCode) => {
        try {
            setDownloading(true)
            getExcelOs(surveyId, campaignId, surveyCode, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileCoo = (surveyId, campaignId, surveyCode, fileName) => {
        try {
            setDownloading(true)
            getExcelCoo(surveyId, campaignId, surveyCode, accessToken, fileName).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileGenericParts = (surveyId, campaignId, surveyCode, isNonDeere, fileName) => {
        try {
            setDownloading(true)
            getExcelGenericParts(surveyId, campaignId, surveyCode, isNonDeere, accessToken, fileName).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    function openDetailScreen(campaign) {
        history.push({
            pathname: '/details',
            state: { campaign: campaign, previous: history.location.pathname }
        })
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const fileName = campaign.templateRevision && campaign.templateRevision !== "" ? `${campaign.surveyCode.toUpperCase()}_Ver${campaign.templateRevision}` : campaign.surveyCode.toUpperCase();
        if (campaign.templateType === CRS_SURVEY_TEMPLATES.PART) {
            getDownloadFileGenericParts(campaign.surveyId, campaign.id, campaign.surveyCode, campaign.isNonDeere, fileName)
        } else {
            switch(campaign.surveyCode){
                case SCBM_CODE:
                    getDownloadFile(campaign.surveyId, campaign.id, fileName)
                    break;
                case  SCBM_INDIRECT:
                    getDownloadFileIndirect(campaign.surveyId, campaign.id, fileName)
                    break;
                case ST:
                    getDownloadFileSubtier(campaign.id)
                    break;
                case OS:
                    getDownloadFileOs(campaign.surveyId, campaign.id, campaign.surveyCode)
                    break;
                case COO:
                    getDownloadFileCoo(campaign.surveyId, campaign.id, campaign.surveyCode, fileName)
                    break;
                default:
                    getDownloadFileGeneric(campaign.surveyId, campaign.id, campaign.surveyCode, fileName)
                    break;
            }
        }
    }

    const spinner = () => (
        <div className='ml-2'>
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
        </div>
    )

    const downloadLink = () => (campaign.surveyCode === CRS_SURVEY_CODES.CM || campaign.surveyCode === CRS_SURVEY_CODES.EM || campaign.surveyCode === CRS_SURVEY_CODES.TPSMEX || (campaign.surveyCode === CRS_SURVEY_CODES.TPS && campaign.templateType === "")) ? null : <Button variant="text-inline" onClick={handleSubmit}>{DOWNLOAD_LINK}</Button>;


    return (
        <ListItem className="list-group-item mb-1">
            <Grid container justifyContent="space-between">
                <Grid item xs={12}>{campaign.id !== 0 ? <Button variant="text-inline" size="large" onClick={e => openDetailScreen(campaign)}>{`# ${campaign.id} - ${campaign.surveyType}`}</Button> : campaign.surveyType}</Grid>
                <Grid item xs={9}>
                    <Typography variant="p" fontWeight="bold">{'Campaign Status: '}</Typography>
                    <Typography variant="p">{campaign.status}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="p" fontWeight="bold">{'End Date: '}</Typography>
                    <Typography variant="p">{getDateFromTimeStamp(campaign.endDate)}</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="p" fontWeight="bold">{'Responses Submitted: '}</Typography>
                    <Typography variant="p">{responsesSubmitted} &nbsp; {downloadingFile ? spinner() : downloadLink()}</Typography>
                </Grid>
                {(campaign.surveyCode !== CM && campaign.surveyCode !== EM) && <Grid item xs={3}>
                    <Typography variant="p" fontWeight="bold">{'Survey Version: '}</Typography>
                    <Typography variant="p">{campaign.templateRevision && campaign.templateRevision !== "" ? campaign.templateRevision : '1'}</Typography>
                </Grid>}
            </Grid>
        </ListItem>
    );
};
